var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bounce","mode":"out-in"}},[(_vm.show)?_c('div',{staticClass:"modal-backdrop"},[_c('div',{staticClass:"modal-container",class:{ center: _vm.center === true }},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }